import { Routes } from '@angular/router';
import { contextBreadcrumbResolver } from './core/routing/bread-crumbs.resolver';

export const routes: Routes = [
  {
    path: '',
    resolve: { breadcrumb: contextBreadcrumbResolver },
    data: { breadcrumbLabel: 'Home' },
    children: [
      {
        path: '',
        loadComponent: () => import('./testing-folder/dropdown-viewer/dropdown-viewer').then(m => m.DropdownViewer)
      },
      {
        path: 'dropdown',
        loadComponent: () => import('./testing-folder/dropdown-viewer/dropdown-viewer').then(m => m.DropdownViewer),
        data: { breadcrumb: 'Dropdown Viewer' }
      },
      {
        path: 'date-time-picker',
        loadComponent: () => import('./testing-folder/date-time-picker-viewer/date-time-picker-viewer').then(m => m.DateTimePickerViewer),
        data: { breadcrumb: 'Date Time Picker Viewer' }
      },
      {
        path: 'ag-grid',
        loadComponent: () => import('./testing-folder/ag-grid-viewer/ag-grid-viewer').then(m => m.AgGridViewer),
        data: { breadcrumb: 'AG Grid Viewer' }
      },
      {
        path: 'search-template',
        loadComponent: () => import('./testing-folder/search-template-viewer/search-template-viewer').then(m => m.SearchTemplateViewer),
        data: { breadcrumb: 'Search Template Viewer' }
      },
      {
        path: 'standard-panel',
        loadComponent: () => import('./testing-folder/standard-panel-viewer/standard-panel-viewer').then(m => m.StandardPanelViewer),
        data: { breadcrumb: 'Standard Panel Viewer' }
      },
      {
        path: 'all-panels',
        loadComponent: () => import('./testing-folder/all-panels-viewer/all-panels-viewer').then(m => m.AllPanelsViewerComponent),
        data: { breadcrumb: 'All Panels Viewer' }
      },
      {
        path: 'test-parser',
        loadComponent: () => import('./testing-folder/test-praser/test-praser').then(m => m.TestPraser),
        data: { breadcrumb: 'Test Parser' }
      },
      {
        path: 'dynamic-form-test',
        loadComponent: () => import('./testing-folder/dynamic-form-test/dynamic-form-test').then(m => m.DynamicFormTest),
        data: { breadcrumb: 'Dynamic Form Test' }
      },
      {
        path: 'kanban',
        loadComponent: () => import('./testing-folder/kanban-viewer/kanban-viewer').then(m => m.KanbanViewer),
        data: { breadcrumb: 'Kanban Viewer' }
      },
      {
        path: 'sms-modal',
        loadComponent: () => import('./testing-folder/sms-modal-viewer/sms-modal-viewer').then(m => m.SmsModalViewer),
        data: { breadcrumb: 'SMS Widget Viewer' }
      },
      {
        path: 'workflow-feedback-viewer',
        loadComponent: () => import('./testing-folder/workflow-feedback-viewer/workflow-feedback-viewer').then(m => m.WorkflowFeedbackViewerPage),
        data: { breadcrumb: 'Workflow Feedback Viewer' }
      },
      {
        path: 'form-marketplace',
        loadComponent: () => import('./testing-folder/form-marketplace-viewer/form-marketplace-viewer').then(m => m.FormMarketplaceViewer),
        data: { breadcrumb: 'Form Marketplace Viewer' }
      },
      {
        path: 'view-task-details',
        loadComponent: () => import('./testing-folder/view-task-details-viewer/view-task-details-viewer').then(m => m.ViewTaskDetailsViewer),
        data: { breadcrumb: 'View Task Details' }
      },
      {
        path: 'job-report-summary',
        loadComponent: () => import('./testing-folder/job-report-summary-viewer/job-report-summary-viewer').then(m => m.JobReportSummaryViewer),
        data: { breadcrumb: 'Job Report Summary' }
      },
      {
        path: 'pdf-builder',
        loadComponent: () => import('./testing-folder/pdf-builder-viewer/pdf-builder-viewer').then(m => m.PdfBuilderViewer),
        data: { breadcrumb: 'PDF Builder Viewer' }
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];

// prod (main.prod.ts) only needs provideRouter for DI, never navigates to testing-folder viewers.
// loadComponent above (not component:) is what actually keeps them out of the shipped bundle —
// an empty prodRoutes alone only blocks navigation, not the static imports of these dev viewers.
export const prodRoutes: Routes = [];
